/**
 * Columns the purchase-order list may order by.
 *
 * Sorting is server-side: the field arrives from the URL and is handed to
 * PostgREST's `order`, so this list is an allowlist rather than a convenience.
 * A field nobody declared here is dropped and the default order applies.
 *
 * The vendor column is deliberately absent — it lives on an embedded resource
 * and ordering across the join is not expressible in the list query.
 */
export const PURCHASE_ORDER_SORT_FIELDS = [
  "balance",
  "date",
  "payment_status",
  "total_amount",
  "total_paid",
  "total_quantity",
  "uid",
] as const;

export type PurchaseOrderSortField = (typeof PURCHASE_ORDER_SORT_FIELDS)[number];

export type PurchaseOrderSortDirection = "asc" | "desc";

/** A server-side order request: the column to sort by and which way. */
export interface PurchaseOrderSort {
  direction: PurchaseOrderSortDirection;
  field: PurchaseOrderSortField;
}

/** Newest first, the order this list has always opened in. */
export const DEFAULT_PURCHASE_ORDER_SORT: PurchaseOrderSort = {
  direction: "desc",
  field: "date",
};

export function isPurchaseOrderSortField(value: string): value is PurchaseOrderSortField {
  return (PURCHASE_ORDER_SORT_FIELDS as readonly string[]).includes(value);
}
